export default __webpack_public_path__ + "static/media/give-key.5de46e08.svg";